import React from 'react';
import { useSearchParams } from 'react-router';
import { Gutter, useApi } from '@axiom/ui';
import type { User, AfcCandidateSearch } from '@axiom/validation';

import type { TalentSearchActiveQueryFilters } from '../../schema/talent-search-active-query-filters';
import { CandidateApi } from '../../api/candidate-api';
import { useTalentSearchCandidateStatsData } from '../../hooks/useTalentSearchCandidateStatsData';

import { TalentSearchEmpty } from './TalentSearchEmpty';
import { TalentSearchCard } from './TalentSearchCard';

export interface TalentSearchFavoritedProps {
  user: User;
  activeFilters: TalentSearchActiveQueryFilters;
  setInquiredCandidate: React.Dispatch<
    React.SetStateAction<AfcCandidateSearch | null>
  >;
  isPricingShown?: boolean;
}

export const TalentSearchFavorited = ({
  user,
  activeFilters,
  setInquiredCandidate,
  isPricingShown,
}: TalentSearchFavoritedProps) => {
  const [, setSearchParams] = useSearchParams();
  const [{ data: candidates }] = useApi(CandidateApi.readFavoriteCandidates());
  useTalentSearchCandidateStatsData({ activeFilters });
  return (
    <div data-test="TALENT_SEARCH_FAVORITED">
      {candidates.length > 0 ? (
        <>
          {candidates.map(c => (
            <Gutter bottom="16px" key={c.id}>
              <TalentSearchCard
                setInquiredCandidate={setInquiredCandidate}
                candidate={c.candidate}
                user={user}
                isPricingShown={isPricingShown}
              />
            </Gutter>
          ))}
        </>
      ) : (
        <Gutter bottom="16px">
          <TalentSearchEmpty
            handleAddFavoriteClick={view => {
              setSearchParams({ view });
            }}
            activeFilters={activeFilters}
            handleClearFiltersClick={() => {}}
            handleReachOutClick={() => {}}
          />
        </Gutter>
      )}
    </div>
  );
};
